<template>
  <base-modal
    :reference="'editRelationHotelPickup'"
    :title="'Editar relaciones por grupo de actividad'"
    :acceptAction="acceptAction"
    :cancelActionText="'Cerrar'"
    :size="'lg'"
  >
    <template v-slot:cancel-action>
        <div></div>
    </template>
    <template v-slot:body v-if="show">
        <div>
            <p>
                Editar la configuración de paradas para el hotel <strong>{{hotelEdit.hotel.name}}</strong>
            </p>
        </div>
        <div>
            <div>
                <table>
                    <thead>
                        <tr>
                            <th>Grupo de actividad</th>
                            <th>Servicio</th>
                            <th>Parada asignada</th>
                            <th>Configurar</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(pickup,idx) in hotelEdit.list_pickups" :key="idx">
                            <admin-hotel-stop-group-edit 
                                :hotel="hotelEdit.hotel"
                                :pickup="pickup"
                                :suprazone="suprazone"
                                :idx="idx"
                            />
                        </tr>
                    </tbody>
                </table>
            </div>
            
        </div>
        <form>
            <div v-if="errors">
                <p class="alert-danger py-2 px-4 my-2 font-weight-bold w-75 mx-auto">
                    Hay errores
                </p>
            </div>
            
        </form>
    </template>
    
  </base-modal>
</template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex';
import BaseModal from "../../Excursions/Booking/Modal/BaseModal";
import AdminHotelStopGroupEdit from './AdminHotelStopGroupEdit';


export default {
  components: {
    BaseModal,
    AdminHotelStopGroupEdit,
  },
  props: {
        hotel: {
            type: Object,
            required: false,
        },
        suprazone: {
            type: Object,
            required: true,
        }
  },
  data() {
    return {
        show: false,
        submitAllowed: false,
    };
  },
  async mounted() {
    this.$root.$on("bv::modal::show", async (bvEvent, modalId) => {
      const current = "editRelationHotelPickup";
      
      if (modalId == current) {
          
        this.show = true
        await this.$store.dispatch('geopoints/getAllGeopointsBySuprazone', {suprazone_id: this.suprazone.id})
        
        // get data
      }
    });
  },
  beforeDestroy() {
      
  },
  methods: {
    async acceptAction() {
        if ( this.errors ) {
            return 
        }
        
        let data = {
            payload: null // {...this.form}
        }
        
        this.$bvModal.hide("editRelationHotelPickup");
        await this.$store.dispatch("hotelStopGroups/forceUIReload", {value: true})
    },
  },
  computed: {
        ...mapGetters(['hotelEdit', 'geopointsListAdmin']),
        errors() {},
        
        
  },
    watch: {
    }
};
</script>